import React from 'react'
import PropTypes from 'prop-types'
import BEMHelper from '@ynap/bem-helper'
import Skeleton from '@ynap/skeleton'

const bem = new BEMHelper('CardSkeleton')

const propTypes = {
    className: PropTypes.string,
}

function CardSkeleton({ className }) {
    return (
        <div className={bem(null, null, className)}>
            <Skeleton className={bem('number')} />
            <Skeleton align="left" />
        </div>
    )
}

CardSkeleton.propTypes = propTypes

export default CardSkeleton
